import HttpService from "@/utils/httpData"

export const uploadImg = (fileData) => {
    // let self = this;
    let apiEndpoint = 'Training/UploadAvata';
    let file = fileData.target.files ? fileData.target.files[0] : null;
    if (file) {
        return HttpService.uploadFile(apiEndpoint, {
            images: file
        }).then(res => {
            return res.data && res.data ? res.data : null;

        }).catch(e => {
            return false
        });
    }

    return false;
}
export const uploadfile = (fileData) => {

    // let self = this;
    let apiEndpoint = 'Training/UploadDocument';
    let file = fileData.target.files ? fileData.target.files[0] : null;
    if (file) {
        return HttpService.uploadFile(apiEndpoint, {
            images: file
        }).then(res => {
            return res.data.data && res.data.data ? res.data.data : null;

        }).catch(e => {
            return false
        });
    }

    return false;
}

export const getListComment = (params = {}) => {
    let apiEndpoint = `Comment/ListComment`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}

export const createComment = (payload) => {
    let apiEndpoint = `Comment/Create`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}

export const updateComment = (payload) => {
    let apiEndpoint = `Comment/Update`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}

export const delComment = id => {
    let apiEndpoint = `Comment/Delete`;
    return HttpService.post(apiEndpoint, {
        id
    }).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}

export const getDetailComment = (params = {}) => {
    let apiEndpoint = `Comment/Detail`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}
export const apiListError = (params = {}) => {
    let apiEndpoint = `Error/List`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}
export const apiErrorCreate = (params = {}) => {
    let apiEndpoint = `Error/Create`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}

export const getGuideActiveCode = (params = {}) => {
    let apiEndpoint = `book/GetActiveGuide`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}


export const getGuideApp = () => {
    let apiEndpoint = `Book/GetTutorial`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}

export const updatecountview = id => {
    let apiEndpoint = `library/update-countview?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const apiUpdateCountdownload = id => {
    let apiEndpoint = `library/update-countdownload?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const fetchNotification = payload => {
    let apiEndpoint = `Notification/GetList`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}

export const apiCountNotificationNotRead = () => {
    let apiEndpoint = `Notification/CountNotificationNotRead`
    return HttpService.get(apiEndpoint)
        .then(res => {
            return res;
        })
}

export const readNotification = id => {
    let apiEndpoint = `Notification/ReadNotification`;
    return HttpService.post(apiEndpoint, {
        id
    }).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}

export const apiListHelp = payload => {
    let apiEndpoint = 'Help/List';
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const apiHelpDetail = (id) => {
    let apiEndpoint = `Help/detail?id=${id}`
    return HttpService.get(apiEndpoint)
        .then(res => {
            return res;
        })
}

export const apiHelpGetVideo = (id) => {
        let apiEndpoint = `Help/GetVideo?typeId=${id}`
        return HttpService.get(apiEndpoint)
            .then(res => {
                return res;
            })
    }
    // export const apiListHelp = payload => {
    //     let apiEndpoint = 'Help/List';
    //     return HttpService.post(apiEndpoint, payload).then(res => {
    //         return res.data ? res.data : null;
    //     }).catch(e => { return false });
    // }
    // export const apiHelpGetVideo = (id) => {
    //     let apiEndpoint = `Help/GetVideo?typeId=${id}`
    //     return HttpService.get(apiEndpoint)
    //         .then(res => {
    //             return res;
    //         })
    // }